/* ============================================================================
   NEOGEN — FAQ & SAFETY page glue (/pages/faq)
   ----------------------------------------------------------------------------
   Ported 2026-07-22, trimmed 2026-07-23 (Fable 5) after the de-nest: the
   page is now a single flat list of details.faq__item accordions (zero
   groups), so the "open the target group on anchor click" helper is gone —
   the masthead anchors point at plain sections (#faq, #safety).

   Accordion easing is the shared assets/neogen-reveal.js layer
   (details.faq__item is in its selector). This file adds only what the
   shared layer doesn't cover: aria-expanded sync on the native `toggle`
   event — neogen-reveal.js mirrors aria-expanded in its click handler but
   returns early under prefers-reduced-motion (native snap), so the toggle
   listener here keeps AT state correct on every path. Idempotent alongside
   reveal.js.
   ============================================================================ */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.neogen-faqx');
    if (!root) return;

    /* aria-expanded sync on native toggle */
    var panels = root.querySelectorAll('details.faq__item');
    panels.forEach(function (d) {
      var s = d.querySelector(':scope > summary');
      if (!s || !s.hasAttribute('aria-expanded')) return;
      var sync = function () {
        s.setAttribute('aria-expanded', d.open ? 'true' : 'false');
      };
      sync();
      d.addEventListener('toggle', sync);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
